<template>
	<Loader :value="promises.fetch" class="page-module-loader" :class="{ 'page-module-loader--initializing': !isReady }">
		<Layout class="page-module">
			<Slider class="page-module__slider" :value="header" :settings="headerSettings"></Slider>
			<div v-for="(item, index) in pageContent" :key="index">
				<component
					:is="getComponent(item['__typename'])"
					:content="item"
					class="page-module__content section"
					:class="'page-module__content--' + item['__typename'].toLowerCase().replace('record', '')"
				/>
			</div>
		</Layout>
	</Loader>
</template>

<script>
import Footer from '@/components/Footer'
import Layout from '@/layouts/Default'
import { mapActions, mapState } from 'vuex'
import Page from '@/components/Page'
import Slider from '@/components/Slider'
import { LoaderComponent } from 'vue-elder-loader'

export default {
	props: {
		slug: {
			type: String,
			default: 'hjem',
		},
	},
	watch: {
		slug: {
			handler(val) {
				return this.fetch(val).then(data => {
					if (!data.page) return this.$router.replace({ name: 'NotFound' })
					this.$nextTick(() => (this.isReady = true))
				})
			},
			immediate: true,
		},
	},
	data() {
		return {
			isReady: false,
		}
	},
	computed: {
		...mapState('Page', ['promises', 'item']),

		pageContent() {
			return this.$path(this.item, 'page.content')
		},
		footerContent() {
			return this.$path(this.item, 'company')
		},
		headerSettings() {
			let header = this.$path(this.item, 'page.header')
			if (!header) return
			return {
				scrollIndicator: header.showScrollIndicator,
				sliderHeadingMaster: header.sliderHeadingMaster,
				sliderHeight: header.sliderHeight,
				fontSize: header.fontSize,
			}
		},

		header() {
			let header = this.$path(this.item, 'page.header')
			if (!header || !header.slides) return []

			return header.slides.map(item => {
				return {
					src: item.sliderType === 'image' ? item.image.url : item.link,
					thumbnail: item.sliderType === 'image' ? item.image.url : item.thumbnail.url,
					type: item.sliderType,
					caption: item.heading,
					button: item.action,
					focalPoint: item.sliderType === 'image' ? item.image.focalPoint : {},
					overlayContent: {
						heading: item.heading,
						uppercase: item.headingUppercase,
					},
					loop: true,
				}
			})
		},
	},
	methods: {
		...mapActions('Page', ['fetch']),
		getComponent(typeName) {
			const base = 'Record'
			switch (typeName) {
				case `LogoSection${base}`:
					return Page.Partners
				case `Text${base}`:
					return Page.TextModule
				case `Relation${base}`:
					return Page.Relations
				case `Slider${base}`:
					return Page.Slider
				case `Contact${base}`:
					return Page.Contact
				case `Newsletter${base}`:
					return Page.Newsletter
				case `Instagram${base}`:
					return Page.Instagram
				case `ContactFormular${base}`:
					return Page.ContactForm
				case `Gap${base}`:
					return Page.Gap
				case `ImageTextModule${base}`:
					return Page.ImageText
				case `Gallery${base}`:
					return Page.Gallery
				case `Masonry${base}`:
					return Page.Masonry
				default:
					return Page.ModuleNotFound
			}
		},
	},

	metaInfo() {
		return {
			title: this.$path(this.item, 'page.title'),
		}
	},

	components: {
		Footer,
		Layout,
		Slider,
		LoaderComponent,
	},
	created() {},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.page-module {
	min-height: 100vh;

	&-loader {
		&--initializing {
			opacity: 0;
		}
	}
}
.page-module__content--contactformular {
	@include respond-below('phone') {
		margin: 0 !important;
	}
}
</style>
